import { IntlProvider, addLocaleData } from 'react-intl';
import localeDataEn from 'react-intl/locale-data/en';
import en from './en';

addLocaleData([
  ...localeDataEn,
]);

export const { defaultLanguage } = process.env;

export const messages = {
  en: en.messages,
};

export const supportedLanguages = Object.keys(messages);

export const formatMessage = (locale, id) => {
  const intlProvider = new IntlProvider({ locale, messages: messages[locale] });
  const { intl } = intlProvider.getChildContext();
  return intl.formatMessage({ id });
};
